import {useBaseCommunity} from "../store/hooks";

export default function isStandardBaseCommunity() {
    const baseCommunity = useBaseCommunity();
    return baseCommunity !== "TheDonald";
}